import {Pipe, PipeTransform} from '@angular/core';
import {NotificationStatus} from 'web-angular-client';

@Pipe({
    name: 'formatNotificationStatus',
    standalone: false
})
export class NotificationStatusPipe implements PipeTransform
{
    transform(notificationStatus: NotificationStatus | null | undefined): string
    {
        if (!notificationStatus)
        {
            return '-';
        }
        return notificationStatus.toString().toLowerCase()
            .split('_')
            .map(word =>
            {
                return word.charAt(0).toUpperCase() + word.slice(1);
            }).join(' ');
    }
}
